import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
import { AiSafeguards } from './AiSafeguards';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  return <section aria-label="Qu'est-ce qu'un prompt" className="bg-transparent" data-id="element-224" data-mp="3mj2ejtmof3jv">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: '20px',
      paddingBottom: '24px'
    }} data-id="element-225" data-mp="37muv4vj3e65n">
        <div className="text-center" data-id="element-226" data-mp="3cninplmyyv1z">
          <h2 className="font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-227" data-mp="3ckcxu46inp57">🤖 Mais qu’est-ce qu’un prompt ?</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-plum/70" data-id="element-228" data-mp="33lrisj096s96">
            Un prompt est simplement une <span className="font-bold text-grape" data-id="element-229" data-mp="wv1qn83i5ba0">instruction structurée</span> donnée à une
            intelligence artificielle pour obtenir un résultat correspondant à un objectif précis.
          </p>
        </div>

        <PromptFlow data-id="element-230" data-mp="30gw2jvi310j7" />
        <PromptDemo data-id="element-231" data-mp="30ge8n5iw6yeg" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-232" data-mp="30fupjlhia3yu">
          <h3 className="text-center font-display text-xl font-black text-plum sm:text-2xl" data-id="element-233" data-mp="2wh5dbw87esgs">📝 Exemple de prompt</h3>
          <p className="mt-2 text-center text-sm text-plum/60" data-id="element-234" data-mp="3a6foxb507cit">Complétez les champs en rouge, copiez, puis ouvrez-le dans votre IA préférée.</p>

          {samplePrompts.length > 1 && <div role="tablist" aria-label="Exemples de prompts" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-235" data-mp="2hk4mduxu71jd">
              {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-grape/40 ${active === i ? 'bg-plum text-white' : 'border border-grape/20 bg-white text-plum/70 hover:text-plum'}`} data-id="element-236" data-mp="2rgzmgi9rd9zr" data-mpi={i}>
                  #{sp.n} · {sp.title}
                </button>)}
            </div>}

          <div className="mt-5" data-id="element-237" data-mp="it1rsxv46w5z">
            <PromptCard key={samplePrompts[active].n} prompt={samplePrompts[active]} data-id="element-238" data-mp="iu4gcz4ysmiq" />
          </div>
        </div>

        <AiSafeguards data-id="element-239" data-mp="nqblwqtg7w05" />
      </div>
    </section>;
}